/**
 * @flow
 */
'use strict';

export const sinceCodes = [
{"code":"1 day"},
{"code":"2 days"},
{"code":"3 days"},
{"code":"4 days"},
{"code":"5 days"},
{"code":"6 days"},
{"code":"1 week"},
{"code":"2 weeks"},
{"code":"3 weeks"},
{"code":"1 month"},
{"code":"2 months"},
{"code":"3 months"},
{"code":"4 months"},
{"code":"5 months"},
{"code":"6 months"},
{"code":"1 year"},
{"code":"2 years"},
{"code":"3 years"},
{"code":"4 years"},
{"code":"5 years"},
{"code":"10 years"},
{"code":"15 years"},
{"code":"20 years"},
{"code":"30 years"}
]
